<template>
  <div class="wt2-aspect-ratio-selector">
    <wt-aspect-ratio-tag
      v-for="ar in supportedAspectRatios"
      :key="ar.name"
      :id="ar.name"
      :show-label="false"
      :show-rectangle="true"
      :scale="ar.name === 'ASPECT_1_1' ? 0.7 : 1"
      :class="{ '-selected': isAspectRatioSelected(ar.name) }"
      :title="`${ar.friendlyName} ${ar.friendlyVal}`"
      @click.native="selectAspectRatio(ar.name)"
    />
  </div>
</template>

<script>
import app from 'app';

export default {
  name: 'story-aspect-ratio-selector',

  props: {
    aspectRatios: { type: Array, required: true },
  },

  computed: {
    supportedAspectRatios() {
      const supportedAspects = Object.keys(app.ASPECT_RATIOS).filter(
        (ratio) => ratio !== 'ALL'
      );

      return supportedAspects.map((k) => app.ASPECT_RATIOS[k]);
    },
  },

  methods: {
    selectAspectRatio(ar) {
      this.$emit('aspect-ratio-selected', { ar });
    },

    isAspectRatioSelected(ar) {
      return this.aspectRatios.includes(ar);
    },
  },
};
</script>

<style lang="scss" scoped>
.wt2-aspect-ratio-selector {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  height: 30px;
  border-bottom: 1px solid #ddd;
  margin-top: 15px;
  padding: 0 15px;

  /deep/ .wt-aspect-ratio-tag {
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 5px;
    }

    &:hover .-rectangle {
      background-color: var(--color-primary-hover);
    }
    &.-selected .-rectangle {
      background-color: var(--color-primary);
    }
  }
}
</style>
